module.exports = __webpack_public_path__ + "static/Choose-Starter.0c448fd7.svg";